import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]

  connect() {
    if (!this.hasBarTarget) return

    this.scrollRoot = this.findScrollParent(this.element) || this.element.closest(".page__body")
    if (!this.scrollRoot) return

    this.boundUpdate = this.update.bind(this)
    this.scrollRoot.addEventListener("scroll", this.boundUpdate, { passive: true })
    window.addEventListener("resize", this.boundUpdate, { passive: true })

    this.resizeObserver = new ResizeObserver(this.boundUpdate)
    this.resizeObserver.observe(this.scrollRoot)
    const grid = this.element.querySelector(".pricing-plans__grid")
    if (grid) this.resizeObserver.observe(grid)

    this.update()
  }

  disconnect() {
    this.scrollRoot?.removeEventListener("scroll", this.boundUpdate)
    window.removeEventListener("resize", this.boundUpdate)
    this.resizeObserver?.disconnect()
    this.clearBarLayout()
  }

  findScrollParent(el) {
    let fallback = null
    let p = el.parentElement
    while (p) {
      const { overflowY, overflow } = getComputedStyle(p)
      const oy = overflowY === "visible" ? overflow : overflowY
      if (oy === "auto" || oy === "scroll") {
        fallback = p
        if (p.scrollHeight > p.clientHeight + 2) return p
      }
      p = p.parentElement
    }
    return fallback
  }

  scrollContentTop() {
    const scrollRoot = this.scrollRoot
    if (!scrollRoot) return 0
    const rootRect = scrollRoot.getBoundingClientRect()
    const rootStyle = getComputedStyle(scrollRoot)
    return rootRect.top + parseFloat(rootStyle.borderTopWidth || "0") + parseFloat(rootStyle.paddingTop || "0")
  }

  update() {
    if (!this.hasBarTarget) return
    if (!this.scrollRoot) return

    const nameEl = this.element.querySelector(".pricing-plans__header-cell .pricing-plans__name")
    if (!nameEl) return

    const contentTop = this.scrollContentTop()
    const anchorTop = nameEl.getBoundingClientRect().top
    const show = anchorTop < contentTop

    this.barTarget.classList.toggle("pricing-plans__sticky-header--visible", show)
    if (show) this.layoutBar()
    else this.clearBarLayout()
  }

  layoutBar() {
    const scrollRoot = this.scrollRoot
    const grid = this.element.querySelector(".pricing-plans__grid")
    if (!scrollRoot || !grid || !this.hasBarTarget) return

    const gridRect = grid.getBoundingClientRect()
    const bar = this.barTarget
    bar.style.top = `${Math.round(this.scrollContentTop())}px`
    bar.style.left = `${Math.round(gridRect.left)}px`
    bar.style.width = `${Math.round(gridRect.width)}px`
  }

  clearBarLayout() {
    if (!this.hasBarTarget) return
    const bar = this.barTarget
    bar.style.removeProperty("top")
    bar.style.removeProperty("left")
    bar.style.removeProperty("width")
  }
}
